import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Sidebar from './components/Sidebar';
import PrivateRoute from './components/PrivateRoute';

import LoginPage from './modules/auth/LoginPage';
import RegistrationPage from './modules/auth/RegistrationPage';
import RequestResetPasswordPage from './modules/auth/RequestResetPasswordPage';
import ResetPasswordPage from './modules/auth/ResetPasswordPage';
import VerifyEmail from './modules/auth/VerifyEmail';
import RegistrationSuccess from './modules/auth/RegistrationSuccess';

import Dashboard from './modules/home/Dashboard';

import ProposalSubmission from './modules/proposal/ProposalSubmission';
import ProposalDetails from './modules/proposal/ProposalDetails';
import ViewSubmissions from './modules/proposal/ViewSubmissions';
import ReviewProposal from './modules/proposal/ReviewProposal';
import ResubmitProposal from './modules/proposal/ResubmitProposal';
import AssignProposal from './modules/proposal/AssignProposal';
import ReviewAssignedProposal from './modules/proposal/ReviewAssignedProposal';

import PendingMeeting from './modules/proposal/PendingMeeting';
import PendingFinalApproval from './modules/proposal/PendingFinalApproval';

import NewRequestWizard from './modules/proposal/children/NewRequestWizard';
import ChildRequestPage from './modules/proposal/children/ChildRequestPage';
import MyRequests from './modules/proposal/children/MyRequests';

import './App.css';
import UserManagement from './modules/users/UserManagement';
import UserProfileForm from './modules/users/UserProfileForm';
import CreateUser from './modules/users/CreateUser';
import Inbox from './pages/Inbox';
import RequestException from './pages/RequestException';
import Exceptions from './pages/Exceptions';

const Layout = ({ children }) => {
  const location = useLocation();

  const path = location.pathname.replace(/^\//, '');
  const hideLayoutRoutes = [
    '', 'login', 'register', 'request-reset-password', 'reset-password',
    'verify-email', 'registration-success'
  ];
  const shouldShowLayout = !hideLayoutRoutes.includes(path);

  return (
    <>
      {shouldShowLayout && (<><Header /><Sidebar /></>)}
      <div className={`app-content ${shouldShowLayout ? 'with-sidebar' : ''}`}>
        {children}
      </div>
    </>
  );
};

export default function App() {
  return (
    <Layout>
      <Routes>
        {}
        <Route index element={<Navigate to="login" replace />} />

        {}
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegistrationPage />} />
        <Route path="request-reset-password" element={<RequestResetPasswordPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route path="verify-email" element={<VerifyEmail />} />
        <Route path="registration-success" element={<RegistrationSuccess />} />

        {}
        <Route path="dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="proposal/submit" element={<PrivateRoute><ProposalSubmission /></PrivateRoute>} />
        <Route path="proposal/view-submissions" element={<PrivateRoute><ViewSubmissions /></PrivateRoute>} />

        {}
        <Route path="proposal/pending-meeting" element={<PrivateRoute><PendingMeeting /></PrivateRoute>} />
        <Route path="proposal/pending-approval" element={<PrivateRoute><PendingFinalApproval /></PrivateRoute>} />

        {}
        <Route path="proposal/:proposalId/request" element={<PrivateRoute><NewRequestWizard /></PrivateRoute>} />
        <Route path="children/:childId" element={<PrivateRoute><ChildRequestPage /></PrivateRoute>} />
        <Route path="children/my" element={<MyRequests />} />
        <Route path="my-requests" element={<PrivateRoute><MyRequests /></PrivateRoute>} />

        {}
        <Route path="proposal/:proposalId" element={<PrivateRoute><ProposalDetails /></PrivateRoute>} />
        <Route path="review-proposal/:proposalId" element={<PrivateRoute><ReviewProposal /></PrivateRoute>} />
        <Route path="proposal/resubmit/:proposalId" element={<PrivateRoute><ResubmitProposal /></PrivateRoute>} />
        <Route path="proposal/assign/:proposalId" element={<PrivateRoute><AssignProposal /></PrivateRoute>} />
        <Route path="review-assigned-proposal/:proposalId" element={<PrivateRoute><ReviewAssignedProposal /></PrivateRoute>} />

        <Route path="admin/users" element={<PrivateRoute><UserManagement /></PrivateRoute>} />
        <Route path="admin/users/:id" element={<PrivateRoute><UserProfileForm /></PrivateRoute>} />
        <Route path="profile" element={<PrivateRoute><UserProfileForm /></PrivateRoute>} />
        <Route path="admin/create-user" element={<PrivateRoute><CreateUser /></PrivateRoute>} />
        <Route path="inbox" element={<PrivateRoute><Inbox /></PrivateRoute>} />
        <Route path="exception/request" element={<RequestException />} />
        <Route path="exceptions" element={<Exceptions />} />

        {}
        <Route path="*" element={<Navigate to="login" replace />} />
      </Routes>
    </Layout>
  );
}
